import { Component, Input } from '@angular/core';

@Component({
    selector: 'help-link',
    template: `
        <a *ngIf="helpWidgetActive" (click)="help()" style="cursor: pointer">
            <mat-icon>help_outline</mat-icon>
        </a>
        <a *ngIf="!helpWidgetActive" target="_blank"  style="cursor: pointer" [href]="'https://attensa.supporthero.io/article/show/' + articleSlug">
            <mat-icon>help_outline</mat-icon>
        </a>
    `
})
export class HelpLinkComponent {
    @Input() articleSlug: string = '';
    
    get helpWidgetActive(): boolean {
        return !!(window as any).supportHeroWidget;
    }

    help(): void {
        (window as any).supportHeroWidget.show({article: this.articleSlug});
    }
}